import { client } from 'lib/evi-api-gateway';
import { log } from 'node:console';

// 學校資源庫頁面
const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api`;

export async function getStorage() {
  return client.post({
    url: `${url}/school_resource/get_storage`
  });
}

export async function getMainAdd(params: any) {
  return client.post({
    url: `${url}/main/add`,
    form: {
      ...params
    }
  });
}

// 获取课件
export async function getFullInfo(params: any) {
  return client.post({
    url: `${url}/main/get_full_info`,
    form: {
      ...params
    }
  });
}
// 获取当前校本资源的显示信息(不包含修改功能)
export async function getFullDisplayInfo(id: any) {
  return client.post({
    url: `${url}/main/get_full_display_info `,
    form: {
      id
    }
  });
}

/*------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------------------------------------------------*/

export async function uploadFile(_permit: any, file: any) {
  return client.uploadOSS(_permit, file);
}

export async function addItem(res_id: any) {
  return client.post({
    url: `${url}/school_resource/add_item`,
    form: {
      res_id
    }
  });
}

function getUploadPermit(i_controller: any, i_action: any, i_fileMeta: any, i_formData = {}) {
  var meta = {
    lastModified: i_fileMeta.lastModified,
    lastModifiedDate: i_fileMeta.lastModifiedDate,
    name: i_fileMeta.name,
    size: i_fileMeta.size,
    type: i_fileMeta.type
  };
  const formData = Object.assign({}, { meta: meta }, i_formData);
  return client.post({
    url: `${url}/upload/token/${i_controller}/${i_action}`,
    form: formData
  });
}

export async function getResourceItemPermit(i_fileMeta: any, i_formData: any) {
  return getUploadPermit('resource_item', 'school_resource', i_fileMeta, i_formData);
}

export async function getResourcePermit(i_fileMeta: any, i_formData: any) {
  return getUploadPermit('resource', 'course', i_fileMeta, i_formData);
}

// (封面)
export async function setCover(params: any) {
  return client.post({
    url: `${url}/school_resource/set_cover`,
    form: {
      ...params
    }
  });
}
// 删除
export async function deleteItem(params: any) {
  return client.post({
    url: `${url}/school_resource/delete_item`,
    form: {
      ...params
    }
  });
}

//当前课件视频
export async function getFullInfovideo(id: any) {
  return client.post({
    url: `${url}/main/get_full_info`,
    form: {
      id
    }
  });
}

export async function adapterBatchAdd(id: any, adapter_item: any) {
  return client.post({
    url: `${url}/item/adapter/batch_add`,
    form: {
      res_id: id,
      adapter_item
    }
  });
}

//新增課程子分類頁面數據
export async function search({
  tag = null,
  keyword = '',
  type = [],
  offset = 0,
  limit = 5,
  show_total = false,
  school_only = false,
  evi_only = false,
  lang,
  vo_lang,
  sort,
  order
}: any) {
  return client
    .post({
      url: `${url}/search`,
      form: {
        tag: tag,
        keyword: keyword || '',
        type: type,
        offset: offset * limit,
        limit: limit,
        school_only: !!school_only ? 'Y' : 'N',
        evi_only: !!evi_only ? 'Y' : 'N',
        lang,
        vo_lang,
        sort,
        order
      }
    })
    .then((ret: any) => {
      return !!show_total ? ret : ret.rows;
    })
    .catch((err: any) => {
      return !!show_total ? { total: 0, rows: [] } : [];
    });
}

// 更改順序
export async function updateSort(id: any, items: any) {
  return client.post({
    url: `${url}/main/update_sort `,
    form: {
      id,
      items
    }
  });
}

// 获取列表，文件夹里面的资料
export async function getResourceList(params: any) {
  return client.post({
    url: `${url}/folder/get_resource_list`,
    form: {
      ...params
    }
  });
}

// 获取额外资源列表 (Extra Resource)
export async function getExtraResourceList(params: any) {
  return client.post({
    url: `${url}/extra_folder/get_resource_list`,
    form: {
      ...params
    }
  });
}

// 学校资源删除
export async function delete_resource(params: any) {
  console.log(params);

  return client.post({
    url: `${url}/main/delete_resource`,
    form: {
      ...params
    }
  });
}

//列表item删除
export async function mainDelete(id: any) {
  const data = await client.post({
    url: `${url}/main/delete`,
    form: { id }
  });
  return data;
}

//添加资源
export async function uploadResource(params: any) {
  const data = await client.post({
    url: `${url}/upload/token/resource_file`,
    form: { ...params }
  });
  return data;
}

// 新增资源
export async function uploadCourseResource(params: any) {
  const data = await client.post({
    url: `${url}/upload/token/course_resource_file`,
    form: { ...params }
  });
  return data;
}

export async function add(params: any) {
  const data = await client.post({
    url: `${url}/main/add`,
    form: {
      ...params
    }
  });
  return data;
}

export async function update(params: any) {
  const data = await client.post({
    url: `${url}/main/update`,
    form: {
      ...params
    }
  });
  return data;
}

export async function uploadBgFile(id: any, bg_id: any) {
  return client.post({
    url: `${url}/main/update_bg`,
    form: {
      id,
      bg_id
    }
  });
}

// 获取课件
export async function getInfo(id: any) {
  return client.post({
    url: `${url}/main/get_full_info`,
    form: {
      id
    }
  });
}
// 列表拖拉後調用
export async function getAddResource(params: any) {
  return client.post({
    url: `${url}/folder/add_resource`,
    form: {
      ...params
    }
  });
}

export async function getVideoList(offset = 0, limit = 12, search: any) {
  return client.post({
    url: `${url}/school_resource/get_video_list`,
    form: {
      offset: offset * limit,
      limit,
      search
    }
  });
}
//获取评语
export async function VerifyUplaod(id: any, course_id: any) {
  return client.post({
    url: `${url}/user_record/get_by_res_id`,
    form: {
      res_id: id,
      course_id
    }
  });
}

// 新建文件夹
export async function getFolder(params: any) {
  return client.post({
    url: `${url}/folder/add`,
    form: {
      ...params
    }
  });
}
// 編輯文件夹名稱
export async function updateFolder(params: any) {
  return client.post({
    url: `${url}/folder/update`,
    form: {
      ...params
    }
  });
}

// 編輯文件夹名稱
export async function update_sr_name(params: any) {
  return client.post({
    url: `${url}/main/update_sr_name`,
    form: {
      ...params
    }
  });
}
// 新建文件夹
export async function getSearch(params: any) {
  return client.post({
    url: `${url}/search`,
    form: {
      ...params
    }
  });
}

// 文件移入文件夹
export async function file_move_to_folder(params: any) {
  return client.post({
    url: `${url}/folder/file_move_to_folder`,
    form: {
      ...params
    }
  });
}

// 文件移入文件夹
export async function upadate_parent_id(params: any) {
  return client.post({
    url: `${url}/folder/update_parent_id`,
    form: {
      ...params
    }
  });
}
//垃圾桶列表
export async function get_recycle_bin_top_level(params: any) {
  return client.post({
    url: `${url}/recycle_bin/get_recycle_bin_top_level`,
    form: {
      ...params
    }
  });
}

// 進回收站
export async function add_recycle(params: any) {
  return client.post({
    url: `${url}/recycle_bin/add_recycle`,
    form: {
      ...params
    }
  });
}

// 還原
export async function restore(params: any) {
  return client.post({
    url: `${url}/recycle_bin/restore`,
    form: {
      ...params
    }
  });
}

// 获取文件夹
export async function getFolderList(params: any) {
  return client.post({
    url: `${url}/folder/get_folder_list`,
    form: {
      ...params
    }
  });
}
// 批量移動
export async function folderMove(params: any) {
  return client.post({
    url: `${url}/folder/move`,
    form: {
      ...params
    }
  });
}

// 清空垃圾桶
export async function cleanAll(params: any) {
  return client.post({
    url: `${url}/main/clean_all`,
    form: {
      ...params
    }
  });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  uploadFile,
  addItem,
  getResourceItemPermit,
  getResourcePermit,
  setCover,
  deleteItem,
  getFullInfovideo,
  adapterBatchAdd,
  search,
  updateSort,
  getResourceList,
  getExtraResourceList,
  mainDelete,
  add,
  update,
  uploadBgFile,
  getInfo,
  getAddResource,
  getVideoList,
  VerifyUplaod,
  getFolder,
  delete_resource,
  uploadResource,
  getFullInfo,
  updateFolder,
  update_sr_name,
  uploadCourseResource,
  upadate_parent_id,
  file_move_to_folder,
  get_recycle_bin_top_level,
  add_recycle,
  restore,
  getFolderList,
  folderMove,
  cleanAll
};
